// Private helper — shared by CommentCard and CommentComposer.
// Not exported from a barrel; import directly from this file.
// No test/showcase/md — connected-tier private helper, not a standalone primitive.
//
// Thin wrapper over the canonical `@ds/display/Avatar` so the comments
// surfaces have a single import line for "photo OR initials, blue tone, md".

import React from "react";
import { Avatar } from "@ds/display/Avatar";

export function CommentAvatar({
  photo,
  initials,
}: {
  photo?: string | null;
  initials: string;
}) {
  return (
    <Avatar
      src={photo ?? undefined}
      initials={initials}
      tone="blue"
      size="md"
    />
  );
}
